import React, { useState, useEffect } from "react";
import './classes/AgentBackendSidebar.css';
 import { configData } from "../config";
 import { Link, useNavigate,useParams,useLocation,useMatch } from 'react-router-dom';


const AgentBackendSidebar = ({ userEmail, userId}) => {
  const [masquerade, setMasquerade] = useState(false);
  const [loading, setLoading] = useState(false);

  const[agentNews, setAgentNews] = useState({});

    

    const loggedin_drupal_uid = localStorage.getItem('drupal_uid');

    const location = useLocation();
    const path = location.pathname;

    const ItemToShowinViewTab = path.includes('/users/') || path.includes('/user/');
        
    const app_url = configData.APP_URL;
     async function getagentnews() {
        
           
                const response = await fetch(
                     app_url+'smwwagency/getagentnews',
                    {
                        method: "GET",
      
                        headers: {
                        'Content-Type': 'application/json',
                        },
                    }
                )           
                const responsedata = await response.json();
                if(responsedata.data.msg === "Success") {
                   setAgentNews(responsedata.data.result);
                } 
                
           
        }
     useEffect(() => {
      
        const mask = localStorage.getItem('masquerade');
        setMasquerade(mask === "1");
        }, []);
  
    useEffect(() => {   

    Promise.all([
                      getagentnews()
                  ])
                  .then(() => {
               
                  
                  })
  }, []);
  



    return(
        
        <div className="agent-right">
            <div id="sidebar-third" className="agent-grid_4">
                <div className="agent-region agent-region-sidebar-third">
                    <div id="block-smww-smww-operations" className="agent-block agent-block-smww"></div>
                       
                            <h1>Quick Links</h1>
                           <ul className="user-opt-menu">
                                    <li>
                                        {/* <a href={`/users/${userEmail}`}>Home</a> */}
                                        <a href={`/user/${loggedin_drupal_uid}`}>Home</a>
                                    </li>
                                    <li>
                                        <a href="/pending_athletes">Athletes Looking for an Agent</a>
                                    </li>
                                    <li>
                                        <a href="/my_athletes">My Athletes</a>
                                    </li>
                                    <li>
                                        <a href="/add_athlete">Create Athlete</a>
                                    </li>
                                    <li>
                                        <a href="/resource_library">Resource Library</a>
                                    </li>
                                    <li>
                                        <a href="/agents-directory">Agent Directory</a>
                                    </li>
                                    <li>
                                        <a href={`/user/${loggedin_drupal_uid}/edit`}>Manage My Public Profile</a>
                                    </li>
                                    <li>
                                        <a href="/my_agents_account">My Account</a>
                                    </li>
                                    </ul>
                        

                            <a style={{color:"#fff"}} href="https://smww.zoom.us/j/804154184" rel="nofollow" class="form-submit" target="_blank">Sunday Chat Link</a>
                       
                           <li className='agent-header-hello-text'><a href={"/user/"+loggedin_drupal_uid+"/edit"} className="agent-quick_link_anchor">Manage My Profile</a></li>
                                <li>
                                <a href="/smww_pay">
                                <input type="button" className='agent-quick-links-reg-button' value="Register for a Course"/>
                                </a>
                                </li>
                                {ItemToShowinViewTab && (
                                    <>
                                        {agentNews.length > 0 && (
                                        <div className="agent-news-container">
                                            <h3>Agent News</h3>
                                            {agentNews.map((agtnews, index)=> ( 
                                                <div key={index}>       
                                                <ul>
                                                    <li style={{border: "1px solid #000", margin: "0 0 12px 21px"}}>
                                                        <div style={{background: "#cde", padding: "5px", fontWeight: "700"}}>
                                                        <a href={agtnews.url}>{agtnews.head}</a>
                                                        </div>
                                                    <div style={{background: "#fff", padding: "5px"}}><div dangerouslySetInnerHTML={{ __html: agtnews.body }} /></div> 
                                                    </li>
                                                </ul>
                                                </div>
                                            ))}
                                        </div>
                                        )}
                                    </> 
                                )}
                                           
                </div>
            </div>
        </div>
        
    );
};

export default AgentBackendSidebar;